import React from "react";
import styled from "styled-components";
import baseUrl from "../constants/baseUrl";
import mediaQueries from "../constants/mediaQueries";
import breakpoints from "../constants/breakpoints";


var Scroll = require("react-scroll");
var Element = Scroll.Element;
var scroller = Scroll.scroller;

const url = baseUrl.services;


const Container = styled.div`
    display: flex;
    justify-content: space-between;
    background:rgb(20,20,20);
    width: 100%;
    @media ${mediaQueries.extraSmallDevices} {
 
  }
  @media ${mediaQueries.smallDevices} {

  }
  @media ${mediaQueries.mediumDevices} {
  
  }
  @media ${mediaQueries.largeDevices} {
 
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {

  }
`;

const Text = styled.div`
    color: white;
    font-family: "Kanit", sans-serif;
    font-weight: 200;
    font-style: normal;
    font-size: 12px;
    padding: 10px;
    margin-left: 10px;
    margin-right: 50px;
    @media ${mediaQueries.extraSmallDevices} {
 
    }
    @media ${mediaQueries.smallDevices} {

    }
    @media ${mediaQueries.mediumDevices} {
    
    }
    @media ${mediaQueries.largeDevices} {
    
    }
    @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {

    }
`;

class TopBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  
  }

  componentDidUpdate() {
   
  }


  render() {
    return (
      <Container>
        <Text>+351 933650062 | geral@burilcnc.pt</Text>
        <Text>Segunda a Sexta: 9:30h - 18:30h | Fechado ao fins de semana</Text>
      </Container>
    );
  }
}

export default TopBar;